import { createInvoicesComponents } from "./createInvoices/navigationComponents";
import { invoicesComponents } from "./invoices/navigationComponents";
import { accountingOrderComponents } from "./accountingOrder/navigationComponents";

export const accountingComponents = [
	...createInvoicesComponents,
	...invoicesComponents,
	...accountingOrderComponents,
];
